import { render, staticRenderFns } from "./Btns.vue?vue&type=template&id=621e4ce7&scoped=true"
import script from "./Btns.vue?vue&type=script&lang=js"
export * from "./Btns.vue?vue&type=script&lang=js"
import style0 from "./Btns.vue?vue&type=style&index=0&id=621e4ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e4ce7",
  null
  
)

export default component.exports